module.exports = __webpack_public_path__ + "media/images/emblems/Belmont-sur-Lausanne-coat_of_arms-2de63e66293e8f6078c27671c6d16cff.svg";